
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Breadcrumb,
  Button,
  Checkbox,
  Label,
  Modal,
  Select,
  Table,
  TextInput,
} from "flowbite-react";
import type { FC } from "react";
import {
  HiCog,
  HiDotsVertical,
  HiExclamationCircle,
  HiHome,
  HiOutlineExclamationCircle,
  HiOutlinePencilAlt,
  HiPlus,
  HiTrash,
} from "react-icons/hi";
import { TbUrgent } from "react-icons/tb";
import { MdEventAvailable } from "react-icons/md";
import { IoIosSend } from "react-icons/io";

import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { createRequestControlMessageReadyParam, createRequestControlMessage } from "../utils/cmsgBuilder";
import generateRandomString from "../MSRP/utilities/generators";
import Global from "../globals/globals";
import { setHandleAgentListResponse } from "../controllers/agentListController";
import { MyRequest } from "../models/MyRequest";
import { ChatContext, ChatContextInterface } from "../components/MSRContext";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const AgentListPage: FC = function () {

  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("all-status");
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [selectedAgents, setSelectedAgents] = useState<string[]>([]);
  const [groupName, setGroupName] = useState("");
  const [isSubscribeOpen, setIsSubscribeopen] = useState(false);
  const [subscribeAgentName, setSubscribeAgentName] = useState<string | null>(null);
  const [agentSubscriptions, setAgentSubscriptions] = useState<Record<string, Record<string, boolean>>>({});
  const { wrapper, requestController, handleAgentListResponse, updateAgentList, agents, addRoom, handleaddServerRequest, handleaddRequest } = useContext(ChatContext) as ChatContextInterface;

  // State to manage dialog visibility and message
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [isOpen, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const { t } = useTranslation("agent");

  useEffect(() => {
    console.log("Page loaded, fetching agent list...");
    updateAgentList("all-status"); // This ensures that agent list is updated on page load
  }, []);
  useEffect(() => {
    updateAgentList(filterStatus);
  }, [filterStatus]);



  // Function to handle dialog close
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleOpenGroupModal = () => {
    updateAgentList("all-status");
    setIsGroupModalOpen(true);

  };

  const handleCloseGroupModal = () => {
    setIsGroupModalOpen(false);
    setSelectedAgents([]);
    setGroupName("");
  };

  const handleAgentSelection = (agentName: string) => {
    setSelectedAgents((prevSelected) => {
      if (prevSelected.includes(agentName)) {
        return prevSelected.filter((name) => name !== agentName);
      } else {
        return [...prevSelected, agentName];
      }
    });
  };

  const handleCreateGroup = () => {
    if (groupName.trim() === "") {
      toast.warning(t("toast.groupNameWarning"));
      return;
    }
    if (selectedAgents.length === 0) {
      toast.warning(t("toast.selectAtLeastOneAgent"));
      return;
    }
    _startGroupChat(groupName, selectedAgents);
    handleCloseGroupModal();
  };

  const _startGroupChat = (groupChatName: string, selectedAgents: string[]) => {
    let params: any;
    const messageId = generateRandomString(16);


    params = {
      "from-name": Global.username + Global.companyDomain,
      "groupchat-id": groupChatName.trim(),
      "user-list": selectedAgents,
    };
    const participants: string[] = [Global.username + Global.companyDomain, ...selectedAgents];

    const newRequest: MyRequest = {
      id: messageId,
      sender: Global.username,
      receiver: participants,
      type: "create-groupchat",
      status: "pending",
      detail: participants,
      incoming: false,
      createdTime: new Date().toISOString(),
      messageID: "grpcht:" + groupChatName.trim(),
    };

    handleaddServerRequest(newRequest);

    wrapper?.sendMsg(createRequestControlMessageReadyParam(messageId, "create-groupchat", params), "application/rechat.cntl+json");
  };


  const sendAgentToAgentRequest = (agentName: string, agentStatus: string) => {
    const username = Global.username + Global.companyDomain;
    // if (agentStatus === "disconnected" || agentStatus === "suspended") {
    //   return (<Modal show={openModal} onClose={() => setOpenModal(false)}>
    //     <Modal.Header className="text-xl font-semibold">
    //       Request Denied
    //     </Modal.Header>
    //     <Modal.Body>
    //       <p className="text-gray-700 dark:text-gray-300">
    //         Cannot request to chat. <strong>{agentName}</strong> is currently{" "}
    //         <strong>{agentStatus}</strong>.
    //       </p>
    //     </Modal.Body>
    //     <Modal.Footer>
    //       <button
    //         onClick={() => setOpenModal(false)}
    //         className="px-4 py-2 text-white bg-primary-500 rounded-lg hover:bg-primary-600"
    //       >
    //         Okay
    //       </button>
    //     </Modal.Footer>
    //   </Modal>
    //   );
    // }
    // Check if there's already a pending request to this agent

    const allRequests: any = localStorage.getItem("requests");
    console.log("allRequests", allRequests);

    if (allRequests) {
      const parsedRequests = JSON.parse(allRequests);
      const existingRequest = parsedRequests.find(
        (request: any) => request.receiver === agentName && request.sender === username && request.type === "agent-to-agent" && request.status === "pending"
      );
      if (existingRequest) {
        setDialogMessage(t("pendingRequestExists", { agentName: agentName }));
        setOpenDialog(true); // Open the dialog with the message
        return; // Do not send a new request if one is already pending
      }
    }

    // If no pending request, proceed to create a new one
    const messageId = generateRandomString(16);

    wrapper?.sendMsg(
      createRequestControlMessage(messageId, "agent-to-agent", `from-name:${username},agent-name:${agentName},reason:chat`),
      "application/rechat.cntl+json"
    );

    const newRequest: MyRequest = {
      id: messageId,
      sender: username!,
      receiver: agentName,
      type: "agent-to-agent",
      status: "pending",
      detail: "no detail",
      incoming: false,
      createdTime: new Date().toISOString(),
      messageID: null,
    };

    handleaddServerRequest(newRequest);
  };


  const sendAgentToAgentUrgentRequest = (agentName: string, agentStatus: string) => {
    const username = Global.username + Global.companyDomain;
    // if (agentStatus === "disconnected" || agentStatus === "suspended") {
    //   return (<Modal show={openModal} onClose={() => setOpenModal(false)}>
    //     <Modal.Header className="text-xl font-semibold">
    //       Request Denied
    //     </Modal.Header>
    //     <Modal.Body>
    //       <p className="text-gray-700 dark:text-gray-300">
    //         Cannot request to chat. <strong>{agentName}</strong> is currently{" "}
    //         <strong>{agentStatus}</strong>.
    //       </p>
    //     </Modal.Body>
    //     <Modal.Footer>
    //       <button
    //         onClick={() => setOpenModal(false)}
    //         className="px-4 py-2 text-white bg-primary-500 rounded-lg hover:bg-primary-600"
    //       >
    //         Okay
    //       </button>
    //     </Modal.Footer>
    //   </Modal>
    //   );
    // }
    // Check if there's already a pending request to this agent

    const allRequests: any = localStorage.getItem("requests");
    console.log("allRequests", allRequests);

    if (allRequests) {
      const parsedRequests = JSON.parse(allRequests);
      const existingRequest = parsedRequests.find(
        (request: any) => request.receiver === agentName && request.sender === username && request.type === "agent-to-agent" && request.status === "pending"
      );
      if (existingRequest) {
        setDialogMessage(t("pendingRequestExists", { agentName: agentName }));
        setOpenDialog(true);
        return;
      }
    }
    const messageId = generateRandomString(16);

    wrapper?.sendMsg(
      createRequestControlMessage(messageId, "agent-to-agent", `from-name:${username},agent-name:${agentName},reason:chat,real-time:true`),
      "application/rechat.cntl+json"
    );

    const newRequest: MyRequest = {
      id: messageId,
      sender: username!,
      receiver: agentName,
      type: "agent-to-agent",
      status: "pending",
      detail: "real-time",
      incoming: false,
      createdTime: new Date().toISOString(),
      messageID: null,
    };

    handleaddServerRequest(newRequest);
  };

  const closeModeWindow = () => {
    setIsSubscribeopen(false);
  };


  useEffect(() => {
    setHandleAgentListResponse(handleAgentListResponse);
  }, []);

  const handleSubscribe = (agentName: string) => {
    setSubscribeAgentName(agentName);

    // Initialize subscriptions for this agent if not already present
    setAgentSubscriptions((prevState) => ({
      ...prevState,
      [agentName]: prevState[agentName] || {
        // suspended: false,
        available: false,
        break: false,
        logedout: false,
      },
    }));

    setIsSubscribeopen(true);
  };


  const subscribeToEvent = (agentName: string, event: string) => {
    console.log(`Subscribing to event: ${event} for agent ${agentName}`);
    const params = {
      id: generateRandomString(16),
      type: "subscribe",
      event: `agent-${event}`,
      subscriber: Global.username + Global.companyDomain,
      "target-name": agentName,
      expire: 86400,
      "inform-method": ["notify", "e-mail"],
      //     "parameters":	{
      // 	"info":	"General info"
      // }
    };
    wrapper?.sendMsg(JSON.stringify(params), "application/rechat.cntl+json");
  };

  const unsubscribeFromEvent = (agentName: string, event: string) => {
    console.log(`Unsubscribing from event: ${event} for agent ${agentName}`);
    const params = {
      id: generateRandomString(16),
      type: "subscribe",
      event: `agent-${event}`,
      subscriber: Global.username + Global.companyDomain,
      "target-name": agentName,
      expire: 0,
      "inform-method": ["notify", "e-mail"],
    };
    wrapper?.sendMsg(JSON.stringify(params), "application/rechat.cntl+json");
  };


  const handleCheckboxChange = (agentName: string, event: string, checked: boolean) => {
    setAgentSubscriptions((prevState) => {
      const updatedSubscriptions = {
        ...prevState,
        [agentName]: {
          ...prevState[agentName],
          [event]: checked,
        },
      };

      // Subscribe or unsubscribe based on the checkbox state
      if (checked) {
        subscribeToEvent(agentName, event);
      } else {
        unsubscribeFromEvent(agentName, event);
      }

      return updatedSubscriptions;
    });
  };

  return (
    <NavbarSidebarLayout >
      <div className="items-center justify-between block p-3 sm:p-4 bg-white border-b border-gray-200 dark:border-gray-700 dark:bg-gray-800">
        <div className="w-full mb-1">
          <div className="mb-4">
            <Breadcrumb className="mb-4">
              <Breadcrumb.Item href="#">
                <div className="flex items-center gap-x-2 sm:gap-x-3">
                  <HiHome className="text-lg sm:text-xl" />
                  <span className="dark:text-white text-sm sm:text-base">{t("home")}</span>
                </div>
              </Breadcrumb.Item>
              <Breadcrumb.Item className="text-sm sm:text-base">{t("agentList")}</Breadcrumb.Item>
            </Breadcrumb>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-white sm:text-xl lg:text-2xl">
              {t("allAgents")}
            </h1>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center w-full p-2 space-y-2 sm:space-y-0 sm:space-x-2 rounded-lg">
              <Select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} className="flex-grow w-full sm:w-auto text-sm">
                <option value="all-status">{t("allStatus")}</option>
                <option value="agent-available">{t("available")}</option>
              </Select>
              <Button
                color={"primary"}
                onClick={() => updateAgentList(filterStatus)}
              >
                {/* <div className="flex items-center justify-center gap-x-1 sm:gap-x-2"> */}
                 {t("updateAgentList")}
                {/* </div> */}
              </Button>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row sm:justify-between items-stretch sm:items-center space-y-2 sm:space-y-0">
            <div className="flex items-center space-x-2 sm:space-x-3 w-full sm:w-auto">
              <Button
                color={"primary"}
                onClick={handleOpenGroupModal}
              >
                <div className="flex items-center justify-center gap-x-1 sm:gap-x-3">
                  <HiPlus className="text-sm sm:text-lg sm:p-x-5" />
                  {t("createGroup")}
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        {/* Mobile Card View */}
        <div className="block sm:hidden p-3 max-h-96 overflow-y-auto pb-24">
          {agents.length > 0 ? (
            <div className="space-y-2">
              {agents.map((agent) => (
                <div key={agent.id} className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-3 shadow-sm">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center space-x-2">
                      <img
                        className="w-8 h-8 rounded-full flex-shrink-0"
                        src="../../images/users/thomas-lean.png"
                        alt="Agent avatar"
                      />
                      <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                          {agent.name.split("@")[0]}
                        </h3>
                      </div>
                    </div>
                    <div className="flex items-center">
                      {agent.status === "agent-available" ? (
                        <div className="h-3 w-3 rounded-full bg-green-400" title={t("available")}></div>
                      ) : (
                        <div className="h-3 w-3 rounded-full bg-red-400" title={t("unavailable")}></div>
                      )}
                    </div>
                  </div>
                  <div className="flex space-x-1">
                    <Button
                      className="bg-gradient-to-br from-purple-300 to-blue-200 text-blue-900 hover:bg-gradient-to-bl focus:ring-blue-300 dark:focus:ring-blue-800 text-lg px-2 py-1 flex-1"
                      onClick={() => sendAgentToAgentRequest(agent.name, agent.status)}
                    >
                      <div className="flex items-center justify-center gap-x-1 dark:text-blue-900">
                        <IoIosSend className="text-xs" />
                        {t("startChat")}
                      </div>
                    </Button>
                    <Button
                      className="bg-gradient-to-br from-purple-300 to-blue-200 text-blue-900 hover:bg-gradient-to-bl focus:ring-blue-300 dark:focus:ring-blue-800 text-lg px-2 py-1 flex-1"
                      onClick={() => sendAgentToAgentUrgentRequest(agent.name, agent.status)}
                    >
                      <div className="flex items-center justify-center gap-x-1">
                        <TbUrgent
                          className="text-xs" />
                        {t("urgentChat")}
                      </div>
                    </Button>
                    <Button
                      className="bg-gradient-to-br from-purple-300 to-blue-200 text-blue-900 hover:bg-gradient-to-bl focus:ring-blue-300 dark:focus:ring-blue-800 text-xs px-2 py-1 flex-1"
                      onClick={() => handleSubscribe(agent.name)}
                    >
                      <div className="flex items-center justify-center gap-x-1">
                        <MdEventAvailable className="text-xs" />
                        {t("subscribe")}
                      </div>
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <p className="text-sm text-gray-500">{t("noResultFound")}</p>
            </div>
          )}
        </div>

        {/* Desktop Table View */}
        <div className="hidden sm:block overflow-x-auto h-full">
          <div className="inline-block min-w-full align-middle h-full">
            <div className="overflow-y-auto shadow h-full max-h-96">
              <Table className="min-w-full divide-y divide-gray-200 dark:divide-gray-600">
                <Table.Head className="bg-gray-100 dark:bg-gray-700 sticky top-0 z-10">
                  <Table.HeadCell></Table.HeadCell>
                  <Table.HeadCell>{t("tableCell.agentName")}</Table.HeadCell>
                  <Table.HeadCell>{t("tableCell.status")}</Table.HeadCell>
                  <Table.HeadCell>{t("tableCell.actions")}</Table.HeadCell>
                </Table.Head>
                {agents.length > 0 && (
                  <Table.Body className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-800">
                    {agents.map((agent) => (
                      <Table.Row key={agent.id} className="hover:bg-gray-100 dark:hover:bg-gray-700">
                        <Table.Cell className="flex items-center p-4 mr-12 space-x-6 whitespace-nowrap lg:mr-0">
                          <img
                            className="w-10 h-10 rounded-full"
                            src="../../images/users/thomas-lean.png"
                            alt="Agent avatar"
                          />
                        </Table.Cell>
                        <Table.Cell className="p-4 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          <div className="text-sm font-normal text-gray-500 dark:text-gray-400">
                            <div className="text-base font-semibold text-gray-900 dark:text-white">
                              {agent.name.split("@")[0]}
                            </div>
                          </div>
                        </Table.Cell>
                        <Table.Cell className="p-4 text-base font-normal text-gray-900 whitespace-nowrap dark:text-white">
                          <div className="flex items-center">
                            {agent.status === "agent-available" ? (
                              <>
                                <div className="mr-2 h-2.5 w-2.5 rounded-full bg-green-400"></div>
                                {agent.status}
                              </>
                            ) : (
                              <>
                                <div className="mr-2 h-2.5 w-2.5 rounded-full bg-red-400"></div>
                                {agent.status}
                              </>
                            )}
                          </div>
                        </Table.Cell>
                        <Table.Cell>
                          <div className="flex items-center gap-x-2 lg:gap-x-3 whitespace-nowrap">
                            <Button
                              color={"chatbar"}
                              onClick={() => sendAgentToAgentRequest(agent.name, agent.status)}
                            >
                              <div className="flex items-center gap-x-1 lg:gap-x-2 dark:text-blue-900">
                                <IoIosSend className="text-base lg:text-lg" />
                                <span className="hidden lg:inline">{t("startMessaging")}</span>
                                <span className="lg:hidden">{t("chatRequest")}</span>
                              </div>
                            </Button>
                            <Button
                              color={"chatbar"}
                              onClick={() => sendAgentToAgentUrgentRequest(agent.name, agent.status)}
                            >
                              <div className="flex items-center gap-x-1 lg:gap-x-2 dark:text-blue-900">
                                <TbUrgent className="text-base lg:text-lg" />
                                <span className="hidden lg:inline">{t("urgentChat")}</span>
                                <span className="lg:hidden">{t("urgentChat")}</span>
                              </div>
                            </Button>
                            <Button
                              color={"chatbar"}
                              onClick={() => handleSubscribe(agent.name)}
                            >
                              <div className="flex items-center gap-x-1 lg:gap-x-2 dark:text-blue-900">
                                <MdEventAvailable className="text-base lg:text-lg" />
                                <span className="hidden lg:inline">{t("subscribeToEvent")}</span>
                                <span className="lg:hidden">{t("subscribe")}</span>
                              </div>
                            </Button>
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                )}
              </Table>
              {agents.length === 0 && (
                <div className="py-8">
                  <p className="items-center justify-center flex-grow text-lg text-center text-gray-500">{t("noResultFound")}</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Group Chat Modal */}
        <Modal show={isGroupModalOpen} onClose={handleCloseGroupModal}>
          <Modal.Header className="text-lg sm:text-xl font-semibold">
            {t("createGroupChat")}
          </Modal.Header>
          <Modal.Body className="p-4 sm:p-6">
            <div className="mt-2 mb-4">
              <Label
                htmlFor="repository-name-input"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                {t("enterGroupNameLabel")}
              </Label>
              <TextInput
                value={groupName}
                id="reason"
                onChange={(e) => setGroupName(e.target.value)}
                placeholder={t("enterGroupNamePlaceholder")}
                required
                className="text-sm sm:text-base"
              />
            </div>

            {agents.length === 0 ? (
              <legend className="mb-4 text-sm sm:text-base text-gray-600 dark:text-gray-400">
               {t("noAgentsAvailable")}
              </legend>
            ) : (
              <fieldset className="flex flex-col gap-3 sm:gap-4 my-6 max-h-40 px-2 sm:max-h-48 overflow-y-auto">
                {agents.map((agent) => (
                  <div className="flex items-center gap-2 sm:gap-3" key={agent.id}>
                    <Checkbox
                      id={String(agent.id)}
                      name={agent.name}
                      value={agent.name}
                      checked={selectedAgents.includes(agent.name)}
                      onChange={() => handleAgentSelection(agent.name)}
                    />
                    <Label htmlFor={String(agent.id)} className="text-sm sm:text-base">
                      {agent.name.split("@")[0]}
                    </Label>
                  </div>
                ))}
              </fieldset>
            )}

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center space-y-2 sm:space-y-0 sm:space-x-4">
              <Button
                onClick={handleCloseGroupModal}
                className="bg-gradient-to-r from-blue-300 to-purple-300 text-gray-900 hover:bg-gradient-to-l hover:from-purple-300 hover:to-blue-200 focus:ring-gray-200 dark:focus:ring-teal-700 w-full sm:w-auto text-sm sm:text-base"
              >
                {t("cancel")}
              </Button>
              <Button
                color={"primary"}
                type="submit"
                onClick={handleCreateGroup}
                className="w-full sm:w-auto text-sm sm:text-base"
              >
                {t("submit")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Subscribe Modal */}
        {subscribeAgentName && (
          <Modal
            onClose={closeModeWindow}
            popup
            show={isSubscribeOpen}
            size="xl"
            theme={{
              content: {
                inner:
                  "relative flex max-h-[90vh] flex-col rounded-lg bg-white shadow dark:bg-gray-800",
              },
            }}
          >
            <Modal.Header className="text-lg sm:text-xl">
              {t("subscribeTitle", { name: subscribeAgentName.split("@")[0] })}
            </Modal.Header>
            <Modal.Body className="p-4 sm:p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                {["available", "break", "help-req"].map((event) => (
                  <div className="flex items-center gap-2 sm:gap-3" key={event}>
                    <Checkbox
                      id={`${subscribeAgentName}-${event}`}
                      name="status"
                      checked={agentSubscriptions[subscribeAgentName]?.[event] || false}
                      onChange={(e) => handleCheckboxChange(subscribeAgentName, event, e.target.checked)}
                    />
                    <Label htmlFor={`${subscribeAgentName}-${event}`} className="text-sm sm:text-base">
                      {event.charAt(0).toUpperCase() + event.slice(1)}
                    </Label>
                  </div>
                ))}
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    </NavbarSidebarLayout>
  );
};

export default AgentListPage;
